export default __webpack_public_path__ + "static/media/Side_Walls_emisionmaop.4a6a9a89.jpg";